import React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import illustrations from "./img";

const styles = theme => ({
  root: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing.unit*2,
  },
  typography: {
    alignSelf: "center",
  },
  img: {
    marginTop: theme.spacing.unit,
    width: "100%",
  }
});

const Unsupported = ({ classes }) => {
  return(
    <div className={classes.root}>
      <Typography className={classes.typography} variant="display1">
        Hmm, device not supported...
      </Typography>
      <img className={classes.img} alt="" src={illustrations.get("feeling_blue")} />
    </div>
  );
};

export default withStyles(styles)(Unsupported);



// WEBPACK FOOTER //
// ./src/components/Illustration/Unsupported.jsx